import { render, staticRenderFns } from "./IntegratorBranchConfigurationsTab.vue?vue&type=template&id=a4ac9f90"
import script from "./IntegratorBranchConfigurationsTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorBranchConfigurationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports